// extracted by mini-css-extract-plugin
export default {"alignVerticalCenter":"error404_alignVerticalCenter__nhs5k","errorPage":"error404_errorPage__eEZpd"};